import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface RutRotInfoModalProps {
  show: boolean;
  onHide: () => void;
}

const RutRotInfoModal: React.FC<RutRotInfoModalProps> = ({ show, onHide }) => {
  const { t } = useTranslation();

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="rut-rot-info-modal"
    >
      <Modal.Header>
        <div className="modal-header-content">
          <div className="header-icon">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="11" stroke="white" strokeWidth="2" />
              <path d="M12 7v5M12 16v1" stroke="white" strokeWidth="2.2" strokeLinecap="round" />
            </svg>
          </div>
          <Modal.Title>{t('RUT_ROT_INFO_MODAL_TITLE')}</Modal.Title>
        </div>
        <div
          className="close-btn"
          onClick={onHide}
          aria-label="Close"
        >
          &#x2715;
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="rut-rot-modal-body">
          <div className="info-callout">
            <div className="callout-icon">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M12 8v5M12 15.5v.5" stroke="white" strokeWidth="2.4" strokeLinecap="round" />
              </svg>
            </div>
            <div className="callout-content">
              <p className="callout-label">{t('RUT_ROT_INFO_MODAL_NOTE')}</p>
              <p className="callout-message">{t('RUT_ROT_INFO_MODAL_MESSAGE')}</p>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button className="ok-btn" onClick={onHide}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RutRotInfoModal;
